export default "__VITE_ASSET__c1274a71__"